import styled from 'styled-components/macro';

const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
`;

export default Label;
